import React, { useContext } from 'react';
import {HashRouter as Router, Route, Switch, Link } from 'react-router-dom';
import AuthContextProvider, { AuthContext }  from './contexts/AuthContext';
import SignalRContextProvider, { SignalRContext }  from './contexts/SignalRContext';
import ProtectedRoute from './components/shared/protected.route';

import Login from './components/account/Login';
import DoctorRegister from './components/account/DoctorRegister';
import Register from './components/account/Register';

import DoctorDashboard from './components/doctor/dashboard/dashboard';
import Appointments from './components/doctor/appoinments/Appoinments';
import MyPatients from './components/doctor/patient/MyPatients'
import PatientProfile from './components/doctor/patient/PatientProfile';
import ScheduleTiming from './components/doctor/schedule/ScheduleTiming';
import Search from './components/doctor/Search/Search';
import DoctorProfile from './components/doctor/profile/DoctorProfile';
import DoctorProfileSetting from './components/doctor/profile/DoctorProfileSetting';
import Invoice from "./components/doctor/invoice/Invoice";
import DoctorReview from './components/doctor/Review/DoctorReview';
import DocChangePassword from './components/account/DocChangePassword';

import PatientDashboard from './components/patient/dashboard/dashboard';
import Booking from './components/patient/booking/booking';
import PatientProfileSetting from './components/patient/profilesetting/ProfileSetting';
import Layout from './components/shared/Layout';
import Checkout from './components/patient/booking/checkout';
import BookingSuccess from './components/patient/booking/BookingSuccess';
import InvoiceViewContainer from './components/shared/InvoiceViewContainer';
import PatChangePassword from './components/account/PatChangePassword';

import ChatApp from './components/Chat/ChatApp';
import VoiceCall from './components/VoiceCall/VoiceCall';
import AddPrescription from './components/doctor/dashboardTabs/AddPrescription';
import AddBilling from './components/doctor/dashboardTabs/AddBilling';
import AddMedicalRecord from './components/doctor/dashboardTabs/AddMedicalRecord';
import ViewPrescriptionContainer from './components/doctor/dashboardTabs/ViewPrescriptionContainer';

function App() {

  return (
    <AuthContextProvider>
      <Router>
        <SignalRContextProvider>
  
          <Layout>
              <Switch>
                <Route exact path='/' component={Login} />
                <Route exact path='/doctorregister' component={DoctorRegister} />
                <Route exact path='/register' component={Register} />
    
                <ProtectedRoute exect path="/chat" component={ChatApp} />
                <ProtectedRoute exect path="/voicecall" component={VoiceCall} />

                <ProtectedRoute exact path='/docchangepassword' component={DocChangePassword} />
                <ProtectedRoute exact path='/doctordashboard' component={DoctorDashboard} />
                <ProtectedRoute exact path='/appointment' component={Appointments} />
                <ProtectedRoute exact path='/mypatients' component={MyPatients} />
                <ProtectedRoute exact path='/PatientProfile' component={PatientProfile} />
                <ProtectedRoute exact path='/scheduletiming' component={ScheduleTiming} />
                <ProtectedRoute exact path='/search' component={Search} />
                <ProtectedRoute exact path='/doctorprofile' component={DoctorProfile} />
                <ProtectedRoute exact path='/doctorprofilesetting' component={DoctorProfileSetting} />
                <ProtectedRoute exact path='/invoice' component={Invoice} />
                <ProtectedRoute exact path='/doctorreview' component={DoctorReview} />
                <ProtectedRoute exact path='/addprescription' component={AddPrescription} />
                <ProtectedRoute exact path='/addbilling' component={AddBilling} />
                <ProtectedRoute exact path='/addmedicalrecord' component={AddMedicalRecord} />
                <ProtectedRoute exact path='/viewprescription' component={ViewPrescriptionContainer} />

                <ProtectedRoute exact path='/patchangepassword' component={PatChangePassword} />
                <ProtectedRoute exact path='/patientdashboard' component={PatientDashboard} />
                <ProtectedRoute exact path='/patientprofilesetting' component={PatientProfileSetting} />
                <ProtectedRoute exact path='/booking' component={Booking} />
                <ProtectedRoute exact path='/checkout' component={Checkout} />
                <ProtectedRoute exact path='/bookingsuccess' component={BookingSuccess} />
                <ProtectedRoute exact path='/invoiceview' component={InvoiceViewContainer} />

              </Switch>
          </Layout>
        </SignalRContextProvider>
      </Router>
    </AuthContextProvider>
  );
}

export default App;
